var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.273,
    height: 12.637,
    viewBox: "0 0 13.273 12.637",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58169",
    "data-name": "Group 58169",
    transform: "translate(-1106.75 -63.402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "north_east_FILL0_wght400_GRAD0_opsz48",
    d: "M160.55-752.147l-.55-.55,6.518-6.518H162.67V-760h5.183v5.183h-.785v-3.848Z",
    transform: "translate(951.92 823.652)",
    fill: "#1c1c1c",
    stroke: "#1c1c1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    y2: 9.822,
    transform: "translate(1107.5 65.467)",
    fill: "none",
    stroke: "#1c1c1c",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x1: 9.822,
    transform: "translate(1107.5 75.29)",
    fill: "none",
    stroke: "#1c1c1c",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 4.911,
    transform: "translate(1107.5 65.467)",
    fill: "none",
    stroke: "#1c1c1c",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    y1: 4.911,
    transform: "translate(1117.323 70.378)",
    fill: "none",
    stroke: "#1c1c1c",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTab);
export default __webpack_public_path__ + "static/media/new-tab.0268e45eb687545dcb8420c0f2443147.svg";
export { ForwardRef as ReactComponent };